(function () {
  window.initShowerOilLp = function () {
    var $ = window.jQuery;
    if (!$ || typeof $.fn.on !== 'function') {
      console.error('[LP] jQuery is required for initShowerOilLp');
      return;
    }
    function bindLoad(fn) {
      var run = function () {
        try { fn(); } catch (e) { console.warn('[LP] initShowerOilLp bindLoad', e); }
      };
      if (document.readyState === 'complete') run();
      else $(window).on('load', run);
    }
    function safeTop(target) {
      try {
        var $el = target && target.jquery ? target : $(target);
        if (!$el || !$el.length) return 0;
        var o = $el.offset();
        return o ? o.top : 0;
      } catch (e) {
        return 0;
      }
    }
    /* --- block 1 --- */
    (function () {
      try {
var sizes = ['l', 'm', 's'];

  // =========================
  // slick初期化関数
  // =========================
  function initSlider($target) {

    if ($target.hasClass('slick-initialized')) return;

    $target.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      swipe: true,
      infinite: false,
      dots: false,
      adaptiveHeight: true,
      responsive: [{
        breakpoint: 960,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false
        }
      }]
    });
  }

  // =========================
  // 全初期化（最初はactiveだけ）
  // =========================
  initSlider($('.lineup-panel-group.active .lineup__list'));

  // =========================
  // サイズ変更
  // =========================
  function changeSize(size) {

    var index = sizes.indexOf(size);
    var $panel = $('.lineup-panel-group.active');
    var $slider = $panel.find('.lineup__list');

    $slider.slick('slickGoTo', index);

    $panel.find('.size-filter li').removeClass('active');
    $panel.find('.size-filter li[data-size="' + size + '"]').addClass('active');

  }

  // =========================
  // タブ切替（ここが重要）
  // =========================
  $('.lineup-tab').on('click', function () {

    var index = $(this).index();

    $('.lineup-tab').removeClass('active');
    $(this).addClass('active');

    var $current = $('.lineup-panel-group.active');
    var $next = $('.lineup-panel-group').eq(index);

    // ★ 今のslider破棄
    $current.find('.lineup__list').slick('unslick');

    // 表示切替
    $('.lineup-panel-group').removeClass('active');
    $next.addClass('active');

    // ★ 新しく初期化
    var $slider = $next.find('.lineup__list');
    initSlider($slider);

    // 初期L
    setTimeout(function () {
      changeSize('l');
    }, 50);

  });

  // =========================
  // サイズボタン（SPのみ）
  // =========================
  $('.size-filter li').on('click', function () {

    if ($(window).width() > 960) return;

    var size = $(this).data('size');
    changeSize(size);

  });

  // =========================
  // next
  // =========================
  $('.lineup-next').on('click', function () {

    var $panel = $('.lineup-panel-group.active');
    var current = $panel.find('.size-filter li.active').data('size');

    var index = sizes.indexOf(current);
    var next = sizes[(index + 1) % sizes.length];

    changeSize(next);

  });

  // =========================
  // prev
  // =========================
  $('.lineup-prev').on('click', function () {

    var $panel = $('.lineup-panel-group.active');
    var current = $panel.find('.size-filter li.active').data('size');

    var index = sizes.indexOf(current);
    var prev = sizes[(index - 1 + sizes.length) % sizes.length];

    changeSize(prev);

  });

  // =========================
  // 初期
  // =========================
  changeSize('l');
      } catch (e) { console.warn('[LP] initShowerOilLp block 1', e); }
    })();

    /* --- block 2 --- */
    (function () {
      try {
var $bodyslider = $('.gift__list').slick({
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        arrows: true,
                        swipe: true,
                        infinite: true,
                        dots: true,
                        responsive: [{
                          breakpoint: 960,
                          settings: {
                            slidesToShow: 1,
                            centerMode: true,
                            centerPadding: '15vw',
                            infinite: true
                          }
                        }]
                      });

                      $('.gift-next').on('click', function () {
                          $bodyslider.slick('slickNext');
                        });
                        $('.gift-prev').on('click', function () {
                          $bodyslider.slick('slickPrev');
                        });
      } catch (e) { console.warn('[LP] initShowerOilLp block 2', e); }
    })();

    /* --- block 3 --- */
    (function () {
      try {
/* ===== slick初期化 ===== */
                      var $fragranceSlider = $('.js-fragrance-slider ul');

                      if ($fragranceSlider.length) {
                        $fragranceSlider.slick({
                          slidesToShow: 1,
                          slidesToScroll: 1,
                          dots: true,
                          arrows: false,
                          infinite: true,
                          swipe: true,
                        });
                      }

                      /* ===== open ===== */
                      $('.js-open-fragrance').on('click', function () {
                        var fragrance = Number($(this).data('fragrance'));
                        var $modal = $('.fragrance-modal');

                        $modal.fadeIn(300);

                        // 初回ズレ対策（遅延＋2回再計算）
                        setTimeout(function () {
                          $fragranceSlider.slick('slickGoTo', fragrance, false);
                          $fragranceSlider.slick('setPosition');

                          requestAnimationFrame(function () {
                            $fragranceSlider.slick('setPosition');
                          });

                        }, 50);
                      });

                      /* ===== prev / next ===== */
                      $('.fragrance-modal .fragrance-next').on('click', function () {
                        $fragranceSlider.slick('slickNext');
                      });

                      $('.fragrance-modal .fragrance-prev').on('click', function () {
                        $fragranceSlider.slick('slickPrev');
                      });

                      /* ===== close ===== */
                      $('.fragrance-modal__close').on('click', function () {
                        $(this).closest('.fragrance-modal').fadeOut(300);
                      });

                      /* ===== 念のため（画像読み込み後のズレ対策） ===== */
                      bindLoad( function () {
                        if ($fragranceSlider.hasClass('slick-initialized')) {
                          $fragranceSlider.slick('setPosition');
                        }
                      });
      } catch (e) { console.warn('[LP] initShowerOilLp block 3', e); }
    })();

    /* --- block 4 --- */
    (function () {
      try {
$("#rb1 .reason-more-btn a").click(function () {
                  $('#rb1').addClass("open");
                  $('#rb1 .reason-more-bg').hide();
                  $('#rb1 .reason-more-btn').hide();
                  $('#rb1 .reason-close-btn').show();
                });

                $("#rb1 .reason-close-btn a").click(function () {
                  $('#rb1').removeClass("open");
                  $('#rb1 .reason-close-btn').hide();
                  $('#rb1 .reason-more-bg').show();
                  $('#rb1 .reason-more-btn').show();
                });
      } catch (e) { console.warn('[LP] initShowerOilLp block 4', e); }
    })();

    /* --- block 5 --- */
    (function () {
      try {
$(".pagetop a").click(function () {
            $("html,body").animate({ scrollTop: 0 }, 600);
          });

          $(window).on('load scroll', function () {

            var pl = $(this).scrollTop();
            if (pl == 0) {
              $(".pagetop").css("display", "none");
            } else {
              $(".pagetop").css("display", "block");
            }

          });

        

        bindLoad( function () {
          window.setTimeout(function () {
            if (location.hash !== "") {
              var targetOffset = safeTop($(location.hash));
              $(window).scrollTop(targetOffset);
            }
          }, 800);
        });
      } catch (e) { console.warn('[LP] initShowerOilLp block 5', e); }
    })();

    /* --- block 6 --- */
    (function () {
      try {
        /* inview は lp-common.js（IntersectionObserver）に一本化。
           ここで opacity:0 を再度かけると表示が消えるため触らない。 */
      } catch (e) { console.warn('[LP] initShowerOilLp block 6', e); }
    })();
  };

  window.destroyShowerOilLp = function () {
    var $ = window.jQuery;
    if (!$) return;
    try {
      $('.slick-initialized').each(function () { $(this).slick('unslick'); });
    } catch (e) {}
    try {
      document.querySelectorAll('.swiper').forEach(function (el) {
        if (el.swiper) el.swiper.destroy(true, true);
      });
    } catch (e) {}
    $('.open-modal').off('click');
    $('.pagetop a').off('click');
  };
})();
